<template>
    <div class="m-portlet m-portlet--full-height m-portlet--tabs  ">
        <div class="m-portlet__head">
            <div class="m-portlet__head-tools">
              <div class="row align-items-center">
                <div class="col-md-9">
                <ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary"
                    role="tablist">
                    <li class="nav-item m-tabs__item">
                        <a class="nav-link m-tabs__link active" data-toggle="tab"
                           href="#m_en" role="tab">
                            {{$t('EN')}}
                        </a>
                    </li>
                    <li class="nav-item m-tabs__item">
                        <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_hu"
                           role="tab">
                            {{$t('HU')}}
                        </a>
                    </li>
                </ul>
                </div>
                <div class="col-md-3">
                    <input type="text" class="form-control m-input m-input--solid" :placeholder="$t('Search...')" v-model="search" />
                  </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane active" id="m_en">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                            <th>{{$t('Key')}}</th>
                            <th>{{$t('Translation')}}</th>
                            <th>{{$t('Actions')}}</th>
                        </tr>
                        <tr>
                            <td><textarea class="form-control" v-model="newTrans.key"></textarea></td>
                            <td><textarea class="form-control" v-model="newTrans.value"></textarea></td>
                            <td>
                                <button type="button" class="btn btn-info" @click="addTranslation('en')">{{$t('Add New')}}</button>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in filter(this.form.langEn)" v-bind:key="index">
                            <td>
                                {{index}}
                            </td>
                            <td>
                                <textarea class="form-control" v-model="form.langEn[index]"></textarea>
                            </td>
                            <td>
                                <button type="button" class="btn btn-success" @click="saveTranslation('en', index)"><i class="far fa-save"></i></button>
                                <button type="button" class="btn btn-danger" @click="deleteTranslation('en', index)"><i class="far fa-trash-alt"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="tab-pane" id="m_hu">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                            <th>{{$t('Key')}}</th>
                            <th>{{$t('Translation')}}</th>
                            <th>{{$t('Actions')}}</th>
                        </tr>
                        <tr>
                            <td><textarea class="form-control" v-model="newTrans.key"></textarea></td>
                            <td><textarea class="form-control" v-model="newTrans.value"></textarea></td>
                            <td>
                                <button type="button" class="btn btn-info" @click="addTranslation('hu')">{{$t('Add New')}}</button>
                            </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in filter(this.form.langHu)" v-bind:key="index">
                            <td>
                                {{index}}
                            </td>
                            <td>
                                <textarea class="form-control" v-model="form.langHu[index]"></textarea>
                            </td>
                            <td>
                                <button type="button" class="btn btn-success" @click="saveTranslation('hu', index)"><i class="far fa-save"></i></button>
                                <button type="button" class="btn btn-danger" @click="deleteTranslation('hu', index)"><i class="far fa-trash-alt"></i></button>
                            </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TranslationList',
  data () {
    return {
      form: {
        langHu: {},
        langEn: {}
      },
      newTrans: {
        key: '',
        value: ''
      },
      search: ''
    }
  },
  computed: {
    apiUrl: function () {
      let ep = JSON.parse(localStorage.getItem('endpoints'))

      if (ep.services['translation']) {
        return ep.services['translation'] + '/' + process.env.API_ENDPOINT + '/admin/translation'
      } else {
        return process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/translation'
      }
    }
  },
  mounted: function () {
    this.$store.commit('loading/change', false)
    let self = this
    this.$nextTick(function () {
      this.form['langHu'] = this.$store.state.loading.languages.hu
      this.form['langEn'] = this.$store.state.loading.languages.en
      if (JSON.stringify(this.form['langEn']) === JSON.stringify({})) {
        setTimeout(function () {
          self.form['langHu'] = self.$store.state.loading.languages.hu
          self.form['langEn'] = self.$store.state.loading.languages.en
        }, 2000)
      }
    })
  },
  methods: {
    filter (items) {
      let newItems = {}
      if (this.search !== '' && this.search !== undefined) {
        for (let it in items) {
          if (items[it] !== null && (items[it].toLowerCase().indexOf(this.search.toLowerCase()) !== -1 || it.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)) {
            newItems[it] = items[it]
          }
        }
      } else {
        newItems = items
      }

      return newItems
    },
    addTranslation (lang) {
      let item = this.newTrans.key
      if (lang === 'hu') {
        this.form.langHu[item] = this.newTrans.value
      } else {
        this.form.langEn[item] = this.newTrans.value
      }

      this.$http.post(this.apiUrl + '/save', {
        lang: lang,
        key: item,
        value: this.newTrans.value
      }, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.$http.get(this.apiUrl + '/' + lang)
          .then(res => {
            this.$store.commit('loading/setLanguage', {lang: lang, payload: res.data})

            this.$translate.setLocaleMessage(lang, res.data)
            this.newTrans.key = ''
            this.newTrans.value = ''
          })
      }).catch(res => {

      })
    },
    deleteTranslation (lang, item) {
      this.$http.delete(this.apiUrl + '/delete', {
        'params': {
          lang: lang,
          key: item
        },
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.$http.get(this.apiUrl + '/' + lang)
          .then(res => {
            this.$store.commit('loading/setLanguage', {lang: lang, payload: res.data})

            this.form['langHu'] = this.$store.state.loading.languages.hu
            this.form['langEn'] = this.$store.state.loading.languages.en

            this.$translate.setLocaleMessage(lang, res.data)
            this.newTrans.key = ''
            this.newTrans.value = ''
          })
      }).catch(res => {

      })
    },
    saveTranslation (lang, item) {
      let value = ''
      if (lang === 'hu') {
        value = this.form.langHu[item]
      } else {
        value = this.form.langEn[item]
      }

      this.$http.post(this.apiUrl + '/save', {
        lang: lang,
        key: item,
        value: value
      }, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.$http.get(this.apiUrl + '/' + lang)
          .then(res => {
            this.$store.commit('loading/setLanguage', {lang: lang, payload: res.data})

            this.$translate.setLocaleMessage(lang, res.data)
            this.newTrans.key = ''
            this.newTrans.value = ''
          })
      }).catch(res => {

      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/translation/TranslationList.vue